import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-md';

import { fromJS } from 'immutable';

import withToggleView from '../../../Components/ToggleView/ToggleView';

const BlockPaymentCard = ({ party, strings, i18n, mode, setViewMode, id, changePaymentCard }) => {
  const contracts = party.contracts
  const contentPaymentCard = <div className='content'>
    <Button
      type="submit"
      onClick={() => changePaymentCard({ payload: contracts })}
      raised
      className='change-payment-card'
    >
      {strings['party.edit.block.button.paymentCard.submit.label'] || 'Imprimer carte tiers payant'}
    </Button>
  </div>

  return contracts?.length > 0 ? <>{contentPaymentCard}</> : <>{strings['party.edit.block.button.paymentCard.noAssociatedContract.label'] || 'Aucun contract associé'}</>

};

BlockPaymentCard.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  changePaymentCard: PropTypes.func,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired // HOC withToggleView
};

BlockPaymentCard.defaultProps = {
  party: {},
  i18n: fromJS({}),
  strings: {},
  // eslint-disable-next-line no-console
  changePaymentCard: (...params) => console.log('changePaymentCard', ...params),
  mode: 'view'
};

const config = {
  title: 'party.edit.block.paymentCard.label',
  defaultTitle: 'Third Party Payment Card',
  name: 'Third Party Payment Card',
  active: true,
};

export default withToggleView(BlockPaymentCard, config);
